import { Directive, HostBinding, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[formControlName],[ngModel],[formControl]',
})
export class ControlStatusDirective {
  @HostBinding('class.is-valid')
  get isValid(): boolean {
    return (this.control?.touched && this.control?.valid) ?? false;
  }

  @HostBinding('class.is-invalid')
  get isInvalid(): boolean {
    return (this.control?.touched && this.control?.invalid) ?? false;
  }

  public constructor(@Self() private control: NgControl) {}
}
